__turbopack_context__.v({
  "introBox": "AccommodationIntro-module__jvM--G__introBox",
  "introSection": "AccommodationIntro-module__jvM--G__introSection",
  "introText": "AccommodationIntro-module__jvM--G__introText",
});
